import * as cl from "classnames"
import * as React from "react"
import * as Model from "../../../../../model"
import { getAxesAnalytiques } from "../../../../../service/sfp/berger-levrault-ws-service"

export default class AxeAnalytiqueField extends React.Component<Props, State> {
	static id = "local-authority-detail-bl-axe"
	private abortController = new AbortController()

	constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
			axes: [],
			error: null,
			fetchingAxesAnalytiques: false
		}
	}

	componentDidMount() {
		if (this.props.idCollectivite) this.forceFetchingAxesAnalytiques()
	}

	componentWillReceiveProps(nextProps: Readonly<Props>): void {
		if (!nextProps.idCollectivite) return this.setState({ axes: [] })

		if (nextProps.idCollectivite !== this.props.idCollectivite)
			return this.forceFetchingAxesAnalytiques()
	}

	componentWillUnmount(): void {
		this.abortController.abort()
	}

	render() {
		const loading = this.props.loading || this.state.fetchingAxesAnalytiques
		const disabled = loading || !this.state.axes.length

		return <div className="field">
		<label className="label" htmlFor={AxeAnalytiqueField.id}>
			Code axe analytique
		</label>

		<span className="control">
			<span className={cl("select is-fullwidth", { "is-loading": loading, "is-danger": this.state.error })}>
				<select
				disabled={disabled}
				id={AxeAnalytiqueField.id}
				required
				value={this.props.value || ""}
				onChange={e => this.handleChange(e)}>
					{this.renderAxesAnalitiquesOptions()}
				</select>
			</span>
		</span>

		{this.state.error &&
		<p className="help is-danger">
			{this.state.error.message}&nbsp;{this.state.error.detail}
		</p>}
	</div>
	}

	private forceFetchingAxesAnalytiques(): void {
		this.abortController.abort()
		this.abortController = new AbortController

		this.setState({ fetchingAxesAnalytiques: true }, () => {
			getAxesAnalytiques(
				this.props.serverAddress,
				this.props.serverPort,
				this.props.idCollectivite,
				this.abortController.signal
			)
			.then(axes => {
				axes.sort((a1, a2) => a1.codeAxe > a2.codeAxe ? 1 : -1)
				this.setState({
					axes,
					error: null,
					fetchingAxesAnalytiques: false
				})
			})
			.catch(reason => {
				this.setState({
					axes: [],
					error: {
						detail: reason instanceof Error ? reason.message : String(reason),
						message: "Impossible d'obtenir les codes d'axes analytiques."
					},
					fetchingAxesAnalytiques: false
				})
			})
		})
	}

	private handleChange(e: React.ChangeEvent<HTMLSelectElement>): void {
		const value = parseInt(e.target.value)
		this.props.onChange(value !== NaN ? value : null)
	}

	private renderAxesAnalitiquesOptions(): React.ReactNode {
		if (this.props.loading) return <option value="">Chargement...</option>

		if (!this.state.axes.length)
			return <option value="">
				Aucun axe analytique disponible
			</option>

		const helpTitle = "Sélectionner un code d'axe analytique"

		const helpOption = <option disabled key={-1} title={helpTitle} value="">
			{helpTitle}
		</option>

		const options = this.state.axes.map((a, i) =>
			<option key={i} title={a.codeAxe} value={a.identifiantAxeGF}>
				{a.codeAxe}
			</option>
		)

		return [helpOption, ...options]
	}
}

interface Props {
	idCollectivite: number | null;
	loading: boolean;
	serverAddress: string;
	serverPort: number;
	value: number | null;
	onChange(value: number | null): void;
}

interface State {
	axes: Model.AxeAnalytique[];
	error: { message: string, detail: string } | null;
	fetchingAxesAnalytiques: boolean;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/berger-levrault-connector/axe-analytique-field.tsx